module.exports = __webpack_public_path__ + "media/images/responsive/page_common/recommend/recommend_reports-ec3847dd45859ab4485dbfe0d9d6674a.jpg";